import { formatPrice,getTodaysCharges } from './functions';

export function prepareABTestData(cart, labels, plan) {
  const fees = cart.feesAndCredits || [];
  const other = cart.otherFeesAndCredits || [];
  const oneTime = cart.oneTimeFeesAndCredits || [];
  const allItems = [...fees, ...other, ...oneTime];

  const planBase = fees[0] || { Item: 'Base Plan', Price: 0 };

  const todaysItems = getTodaysCharges(fees, other, oneTime, labels);
  const totalToday = allItems.reduce((acc, item) => acc + Number(item.Price), 0);
  todaysItems.push({ Item: labels.totalChargedToday, Price: totalToday });

  const feesTotal = fees.reduce((acc, item) => acc + Number(item.Price), 0);
  const otherTotal = other.reduce((acc, item) => acc + Number(item.Price), 0);
  const month1Total = feesTotal + otherTotal;

  const month1Items = [
    ...other,
    { Item: labels.monthlyAddOnsTotal, Price: otherTotal },
    { Item: labels.basePlanAfterDiscounts, Price: feesTotal },
    { Item: labels.addOnsPreviewOrder, Price: otherTotal },
    { Item: labels.firstMonthTotal, Price: month1Total },
  ];

  const planWithoutDiscount = {
    Item: labels.basePlanNoDiscount,
    Price: planBase.Price,
  };

  const month12Items = [
    planWithoutDiscount,
    ...other.filter((item) => !item.Item.toLowerCase().includes('for 3 mos.')),
  ];

  const month12Total = month12Items.reduce((acc, item) => acc + Number(item.Price), 0);
  month12Items.push({ Item: labels.afterYearTotal, Price: month12Total });

  return {
    todaysItems,
    totalToday,
    month1Items,
    month1Total,
    month12Items,
    month12Total,
  };
}
